import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../public/img/pages/record-type-lookup/open-command-prompt-windows.png'
import _imports_1 from '../../public/img/pages/record-type-lookup/open-terminal-mac.png'
import _imports_2 from '../../public/img/pages/record-type-lookup/open-terminal-linux.png'


const _hoisted_1 = { class: "bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col justify-center max-w-lg min-h-[calc(100vh-250px)] mx-auto text-center" }
const _hoisted_4 = {
  class: "text-base flex flex-col items-center justify-center",
  autocomplete: "off"
}
const _hoisted_5 = { class: "font-extrabold text-4xl max-w-full my-8" }
const _hoisted_6 = { class: "mt-8 mb-20 text-center max-w-full h-20 w-[500px] text-neutral-800" }
const _hoisted_7 = { class: "prose max-w-6xl prose-indigo mt-6 mx-auto bg-white p-6 rounded-t shadow" }
const _hoisted_8 = { class: "flex flex-col justify-between md:flex-row" }
const _hoisted_9 = { class: "inline-block text-2xl mt-0" }
const _hoisted_10 = { class: "shrink-0 flex items-center mb-5 text-sm font-medium leading-4 md:float-right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "hidden mr-2 sm:inline" }, "Jump to", -1)
const _hoisted_12 = {
  type: "button",
  class: "inline-flex items-center rounded-md border border-[#3a0161] bg-white px-3 py-2 text-[#3a0161] shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
}
const _hoisted_13 = { class: "first-letter:uppercase" }
const _hoisted_14 = { class: "md:grid md:gap-6 md:grid-cols-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { key: 6 }
const _hoisted_22 = { key: 7 }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { id: "windows" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("em", null, "command prompt", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  loading: "lazy",
  class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
  src: _imports_0,
  alt: "Open a command prompt in Windows",
  width: "970",
  height: "768"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("code", null, "example.com", -1)
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "Non-authoritative answer", -1)
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("code", null, "nslookup", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("code", null, "Resolve-DnsName", -1)
const _hoisted_33 = { id: "mac" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("em", null, "terminal", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  loading: "lazy",
  class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
  src: _imports_1,
  alt: "Open a terminal on a Mac",
  width: "1362",
  height: "862"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("code", null, "example.com", -1)
const _hoisted_37 = ["src", "alt"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "ANSWER SECTION", -1)
const _hoisted_39 = { id: "linux" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("em", null, "terminal", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  loading: "lazy",
  class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
  src: _imports_2,
  alt: "Open a terminal in Linux",
  width: "754",
  height: "472"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("code", null, "example.com", -1)
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("strong", null, "ANSWER SECTION", -1)
const _hoisted_45 = ["src", "alt"]
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<h2>What are CNAME records and how do they work?</h2><p>The DNS CNAME record can be configured to delegate the configuration of DNS records to some other DNS zone. In other words, it tells DNS clients (like web browsers) to query the DNS records of a different domain, and treat them as if they were for the domain with the CNAME record.</p><p>The most common use case for this is when you want to configure a custom domain name for a third party service. In this case you control your domain name, but the third party service controls the servers that host it. It would be inconvenient if you&#39;d have to change your DNS settings whenever this service changes its IP addresses. This is why they commonly request you to create a CNAME record instead. That way you remain in control of your domain name, but they can change the DNS configuration of their service at any time. When such a record exists for a domain name or subdomain, the content of the record is said to be the canonical name of that domain.</p><h2>Restrictions on CNAME records</h2><p>There are a couple of restrictions on the configuration of CNAME records:</p><ul><li>At most one CNAME record may exist for any domain or subdomain. See <a href=\"https://www.rfc-editor.org/rfc/rfc2181#section-10.1\" target=\"_blank\" rel=\"noopener noreferrer\">section 10.1 of RFC 2181</a>.</li><li>The content of a CNAME record must be a valid domain name. It cannot be an ip address. See <a href=\"https://www.rfc-editor.org/rfc/rfc1034#section-3.6\" target=\"_blank\" rel=\"noopener noreferrer\">section 3.6 of RFC 1034</a>.</li><li>If a CNAME record is present, no other records may be present, except for DNSSEC records (RRSIG, DNSKEY, DS, NSEC and NSEC3PARAM). See <a href=\"https://www.rfc-editor.org/rfc/rfc2181#section-10.1\" target=\"_blank\" rel=\"noopener noreferrer\">section 10.1 of RFC 2181</a>.</li><li>Root domains should not have a CNAME record. Because of the previous restriction, the root domain could no longer have NS or SOA records.</li><li>MX and NS records must not point to a domain name that has a CNAME record. See <a href=\"https://www.rfc-editor.org/rfc/rfc2181#section-10.3\" target=\"_blank\" rel=\"noopener noreferrer\">section 10.3 of RFC 2181</a>.</li></ul>", 6)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h2", { id: "otherLookup" }, "How to lookup other record types", -1)

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { getRecordType, recordTypes } from '@/common/recordTypes';
import Icon from '@/components/micro/IconComponent.vue';
import MetaTags from '@/components/MetaTags.vue';
import { LargeRectangle, MediumRectangle } from '@/common/adSizes';
import AdUnit from '@/components/ads/AdUnit.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { RecordTypeLookup } from '@/common/adSlots';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordTypeLookup',
  props: {
  routerRecordType: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const platforms: Array<'windows' | 'mac' | 'linux'> = [
  'windows',
  'mac',
  'linux',
];

const router = useRouter();

const recordType = computed(() => getRecordType(props.routerRecordType));

function redirectTo(domain: string): void {
  if (recordType.value.lower === 'spf') {
    router.push(`/domains/${domainNameToUrlPath(domain)}/email/${recordType.value.lower}/`);
  } else {
    router.push(`/domains/${domainNameToUrlPath(domain)}/dns-records/${recordType.value.lower}/`);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: `${_unref(recordType).upper} Lookup`,
        description: `Find ${_unref(recordType).plural} (${_unref(recordType).upper} DNS records) for any domain or website. Check if the ${_unref(recordType).upper} records have been configured correctly.`,
        url: `https://www.nslookup.io/${_unref(recordType).lower}-lookup/`
      }, null, 8, ["title", "description", "url"])
    ])),
    _createVNode(HeaderComponent, {
      "domain-search-to-url": (encodedDomain) => `/domains/${encodedDomain}/dns-records/${_unref(recordType).lower}/`,
      "search-button-text": `Find ${_unref(recordType).upper} records`
    }, null, 8, ["domain-search-to-url", "search-button-text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(recordType).upper) + " lookup", 1),
            _createVNode(DomainSearch, {
              class: "h-12 mb-6 max-w-full w-[500px]",
              autofocus: "",
              emphasize: "",
              buttonText: ['soa', 'spf', 'cname'].includes(_unref(recordType).lower) ? `Find ${_unref(recordType).upper} record` : `Find ${_unref(recordType).upper} records`,
              "placeholder-text": _unref(recordType).upper === 'PTR' ? 'IP address or domain name' : 'Domain name',
              onSubmitted: redirectTo
            }, null, 8, ["buttonText", "placeholder-text"]),
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode("Find all " + _toDisplayString(_unref(recordType).plural) + " for a domain name with this online DNS " + _toDisplayString(_unref(recordType).upper) + " checker. For example, try ", 1),
              _createVNode(DnsRecordsLink, {
                page: _unref(recordType).upper,
                domain: _unref(recordType).exampleDomains[0],
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, null, 8, ["page", "domain"]),
              _createTextVNode(" or "),
              _createVNode(DnsRecordsLink, {
                page: _unref(recordType).upper,
                domain: _unref(recordType).exampleDomains[1],
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, null, 8, ["page", "domain"]),
              _createTextVNode(" to view their " + _toDisplayString(_unref(recordType).upper) + " records. ", 1)
            ]),
            _createVNode(AdUnit, {
              class: "mt-8 mx-auto",
              config: _unref(RecordTypeLookup)
            }, null, 8, ["config"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, "How to lookup " + _toDisplayString(_unref(recordType).upper) + " records", 1),
            _createElementVNode("span", _hoisted_10, [
              _hoisted_11,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(platforms, (platform) => {
                return _createVNode(_component_router_link, {
                  key: platform,
                  to: `#${platform.toLowerCase()}`,
                  class: "no-underline mr-2 last:mr-0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_12, [
                      _createVNode(Icon, {
                        icon: platform,
                        class: "mr-2"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(platform), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              (_unref(recordType).upper === 'A')
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createTextVNode("A records can be configured by the owner of a domain name. They are used to link IPv4 addresses to a domain name. IPv6 addresses are stored as AAAA records. Both IPv4 and IPv6 addresses are most commonly used by web browsers like Google Chrome, in order to find the web server that should be contacted to display a website. Strictly speaking, A and AAAA records are not limited to this, but other uses are rare in comparison. "),
                    (_unref(recordType).learningPage !== undefined)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: _unref(recordType).learningPage
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Learn more about A records.")
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_unref(recordType).upper === 'AAAA')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                      _createTextVNode("AAAA records can be configured by the owner of a domain name. They are used to link IPv4 addresses to a domain name. IPv6 addresses are stored as A records. Both IPv4 and IPv6 addresses are most commonly used by web browsers like Google Chrome, in order to find the web server that should be contacted to display a website. Strictly speaking, A and AAAA records are not limited to this, but other uses are rare in comparison. "),
                      (_unref(recordType).learningPage !== undefined)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _unref(recordType).learningPage
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Learn more about AAAA records.")
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_unref(recordType).upper === 'CNAME')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _createTextVNode("CNAME records can be configured by the owner of a domain name. They can be used to configure the same DNS records for two domain names without storing the information twice. When a domain name has a CNAME record pointing to another domain, that other domain name is said to be the canonical name for the domain with the CNAME record. "),
                        (_unref(recordType).learningPage !== undefined)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: _unref(recordType).learningPage
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Learn more about CNAME records.")
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_unref(recordType).upper === 'MX')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _createTextVNode("MX records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. The purpose of MX records is to publish the location of mail servers of a domain name. Whenever a mail client sends an email, it first looks up the MX records of the recipient. "),
                          (_unref(recordType).learningPage !== undefined)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: _unref(recordType).learningPage
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Learn more about MX records.")
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_unref(recordType).upper === 'NS')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                            _createTextVNode("NS records can be configured by the owner of a domain name. They are used to store the location of the authoritative DNS servers for that domain name. That means that these name servers will be seen as the source of truth for the DNS records for that domain name. Whenever a recursive DNS server doesn't have DNS records in its cache, it will trace the authoritative DNS server with NS lookups, and query that server for the DNS records. "),
                            (_unref(recordType).learningPage !== undefined)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: _unref(recordType).learningPage
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Learn more about NS records.")
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_unref(recordType).upper === 'SOA')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                              _createTextVNode("SOA records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. The purpose of SOA records is to announce that a new DNS zone starts somewhere in the tree of DNS names. An example is the delegation from a top level domain (e.g. .com) to the owner of a domain name (e.g. example.com). This start of authority contains some information about the child zone, which we explain in detail in our "),
                              (_unref(recordType).learningPage !== undefined)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: _unref(recordType).learningPage
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("article about SOA records.")
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_unref(recordType).upper === 'TXT')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                _createTextVNode("TXT records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. TXT records are often used to verify domain ownership with third parties. A Sender Policy Framework (SPF) record can usually also be found with a TXT lookup. "),
                                (_unref(recordType).learningPage !== undefined)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: _unref(recordType).learningPage
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Learn more about TXT records.")
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                _createTextVNode(_toDisplayString(_unref(recordType).upper) + " records can be configured by the owner of a domain name. They are used to store information in the DNS, which can be looked up by anyone. Each record type has a different purpose. ", 1),
                                (_unref(recordType).learningPage !== undefined)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: _unref(recordType).learningPage
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Learn more about " + _toDisplayString(_unref(recordType).upper) + " records.", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ])),
              _createElementVNode("p", null, _toDisplayString(_unref(recordType).upper) + " records are configured in DNS. But how can you look up these " + _toDisplayString(_unref(recordType).upper) + " records? That depends on the operating system you are using. Windows, Linux and Mac all have a different way of finding " + _toDisplayString(_unref(recordType).upper) + " records. The sections below contain instructions for each operating system.", 1)
            ]),
            _createElementVNode("img", {
              class: "w-full md:mb-0 md:mt-6",
              src: `img/pages/record-type-lookup/${_unref(recordType).cli}-lookup-mac.png`,
              alt: `Example output of a ${_unref(recordType).upper} lookup query`
            }, null, 8, _hoisted_23)
          ]),
          _createElementVNode("h2", _hoisted_24, "How to lookup " + _toDisplayString(_unref(recordType).upper) + " records on Windows", 1),
          (_unref(recordType).windowsSupport)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", null, "To check the " + _toDisplayString(_unref(recordType).upper) + " records for a certain domain name on Windows, follow these steps:", 1),
                _createElementVNode("ol", null, [
                  _createElementVNode("li", null, [
                    _createTextVNode("Open a "),
                    _hoisted_25,
                    _createTextVNode(" by navigating to "),
                    _createElementVNode("strong", null, [
                      _createVNode(Icon, { icon: "click" }),
                      _createTextVNode(" Start → "),
                      _createVNode(Icon, { icon: "click" }),
                      _createTextVNode(" 'Type here to search' → "),
                      _createVNode(Icon, { icon: "type" }),
                      _createTextVNode(" 'cmd' → "),
                      _createVNode(Icon, { icon: "click" }),
                      _createTextVNode(" Open")
                    ]),
                    _createTextVNode("."),
                    _hoisted_26
                  ]),
                  _createElementVNode("li", null, [
                    _createTextVNode("Type "),
                    _createElementVNode("strong", null, [
                      _createVNode(Icon, { icon: "type" }),
                      _createTextVNode(),
                      _createElementVNode("code", null, "nslookup -q=" + _toDisplayString(_unref(recordType).cli) + " example.com", 1)
                    ]),
                    _createTextVNode(" and hit "),
                    _createElementVNode("strong", null, [
                      _createVNode(Icon, { icon: "type" }),
                      _createTextVNode(" [enter]")
                    ]),
                    _createTextVNode(" to get the " + _toDisplayString(_unref(recordType).upper) + " records for ", 1),
                    _hoisted_27,
                    _createTextVNode("."),
                    _createElementVNode("img", {
                      loading: "lazy",
                      class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                      src: `img/pages/record-type-lookup/${_unref(recordType).cli}-lookup-windows.png`,
                      alt: `${_unref(recordType).upper} lookup in Windows`
                    }, null, 8, _hoisted_28)
                  ]),
                  _createElementVNode("li", null, [
                    _createTextVNode("The " + _toDisplayString(_unref(recordType).upper) + " records are listed below the ", 1),
                    _hoisted_29,
                    _createTextVNode(" heading.")
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_30, [
                _createTextVNode("The " + _toDisplayString(_unref(recordType).upper) + " record type cannot be looked up in Windows. Neither ", 1),
                _hoisted_31,
                _createTextVNode(", nor Powershell's "),
                _hoisted_32,
                _createTextVNode(" has support for it. You can either install WSL and follow the Linux instructions below, or use an online " + _toDisplayString(_unref(recordType).upper) + " lookup tool like the one on the top of this page.", 1)
              ])),
          _createElementVNode("h2", _hoisted_33, "How to lookup " + _toDisplayString(_unref(recordType).upper) + " records on Mac OS", 1),
          _createElementVNode("p", null, "To check the " + _toDisplayString(_unref(recordType).upper) + " records for a certain domain name on a Mac, follow these steps:", 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Open a "),
              _hoisted_34,
              _createTextVNode(" by entering "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [command] + [space] → "),
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" 'terminal.app' → "),
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [enter]")
              ]),
              _createTextVNode("."),
              _hoisted_35
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Type "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(),
                _createElementVNode("code", null, "dig example.com " + _toDisplayString(_unref(recordType).cli), 1)
              ]),
              _createTextVNode(" and hit "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [enter]")
              ]),
              _createTextVNode(" to get the " + _toDisplayString(_unref(recordType).upper) + " records for ", 1),
              _hoisted_36,
              _createTextVNode("."),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${_unref(recordType).cli}-lookup-mac.png`,
                alt: `${_unref(recordType).upper} lookup on a Mac`
              }, null, 8, _hoisted_37)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("The " + _toDisplayString(_unref(recordType).upper) + " records are listed below the ", 1),
              _hoisted_38,
              _createTextVNode(" heading.")
            ])
          ]),
          _createElementVNode("h2", _hoisted_39, "How to lookup " + _toDisplayString(_unref(recordType).upper) + " records on Linux", 1),
          _createElementVNode("p", null, "To check the " + _toDisplayString(_unref(recordType).upper) + " records for a certain domain name on Linux, follow these steps:", 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Open a "),
              _hoisted_40,
              _createTextVNode(" by entering "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [Super] → "),
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" 'terminal' → "),
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [enter]")
              ]),
              _createTextVNode("."),
              _hoisted_41
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Type "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(),
                _createElementVNode("code", null, "dig example.com " + _toDisplayString(_unref(recordType).cli), 1)
              ]),
              _createTextVNode(" and hit "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [enter]")
              ]),
              _createTextVNode(" to get the " + _toDisplayString(_unref(recordType).upper) + " records for ", 1),
              _hoisted_42,
              _createTextVNode("."),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${_unref(recordType).cli}-lookup-linux.png`,
                alt: `${_unref(recordType).upper} lookup in Linux`
              }, null, 8, _hoisted_43)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("The " + _toDisplayString(_unref(recordType).upper) + " records are listed below the ", 1),
              _hoisted_44,
              _createTextVNode(" heading.")
            ])
          ]),
          _createElementVNode("h2", null, "How to find " + _toDisplayString(_unref(recordType).upper) + " records", 1),
          _createElementVNode("p", null, "To check the " + _toDisplayString(_unref(recordType).upper) + " records of a domain, follow these steps:", 1),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode("Open the "),
              _createVNode(_component_router_link, {
                to: `/${_unref(recordType).lower}-lookup/`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(recordType).upper) + " lookup tool", 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createTextVNode("."),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${_unref(recordType).lower}-lookup-tool.png`,
                alt: `Open the ${_unref(recordType).upper} lookup tool`
              }, null, 8, _hoisted_45)
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Enter the domain name and hit "),
              _createElementVNode("strong", null, [
                _createVNode(Icon, { icon: "type" }),
                _createTextVNode(" [enter]")
              ]),
              _createTextVNode("."),
              _createElementVNode("img", {
                loading: "lazy",
                class: "block my-2 w-full border border-black/10 rounded-md shadow md:w-1/2",
                src: `img/pages/record-type-lookup/${_unref(recordType).lower}-records-example.png`,
                alt: `Example DNS ${_unref(recordType).upper} records`
              }, null, 8, _hoisted_46)
            ]),
            _createElementVNode("li", null, "The tool will query the " + _toDisplayString(_unref(recordType).upper) + " records and shown them at the top of the page.", 1)
          ]),
          (_unref(recordType).upper === 'CNAME')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_47,
                _createElementVNode("p", null, [
                  _createVNode(_component_router_link, { to: "/learning/dns-record-types/cname/" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Learn more about CNAME records.")
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_53,
          _createElementVNode("p", null, [
            _createTextVNode("There are other types of DNS records then just " + _toDisplayString(_unref(recordType).upper) + ". The most commonly used DNS record types are A, AAAA, CNAME, NS, TXT, MX and SOA. If you'd like to look up all records of these record types, you can do so with ", 1),
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode("nslookup")
              ]),
              _: 1
            }),
            _createTextVNode(". Click any of the record types below to find DNS records for that specific record type. ")
          ]),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recordTypes).filter((other) => other.upper !== _unref(recordType).upper), (otherRecordType, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_router_link, {
                  to: `/${otherRecordType.lower}-lookup/`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(otherRecordType.upper) + " lookup", 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(" — " + _toDisplayString(otherRecordType.description), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})